module.exports = __webpack_public_path__ + "img/ver.e9ad7fac.svg";